import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BasicInputWithExtras } from '../../../../components/common/inputs/BasicInputWithExtras';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { sellTractorSurveySteps } from '../../../../constants/survey/sellTractorSurvey';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { InputValue } from '../../../../interfaces/Element.interfaces';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { PriceHelperText } from '../../components/PriceHelperText';
import { SellTractorSurveyPageWrapper } from '../SellTractorSurveyPageWrapper';

export const SellTractorSurveyHopeSellingPricePage = () => {
  const navigate = useNavigate();

  const [hopeSellingPrice, setHopeSellingPrice] = useState<number>();

  const dispatch = useAppDispatch();
  const userSellTractorSurveyActions = userSellTractorSurveySlice.actions;
  const userSellTractorSurveySelector = useAppSelector((state) => state.userSellTractorSurvey);

  const currentStep = sellTractorSurveySteps.STEP6;
  const steps = Object.keys(sellTractorSurveySteps);

  useEffect(() => {
    const { hopeSellingPrice } = userSellTractorSurveySelector;

    if (hopeSellingPrice) {
      setHopeSellingPrice(hopeSellingPrice);
    }
  }, [userSellTractorSurveySelector.hopeSellingPrice]);

  return (
    <SellTractorSurveyPageWrapper
      headerTitle={'판매 가격을 입력해 주세요'}
      canConfirm={hopeSellingPrice !== undefined}
      confirmHandler={() => {
        dispatch(userSellTractorSurveyActions.changeHopeSellingPrice(hopeSellingPrice!));
        navigate('/survey/progress/sell-tractor/extra-info-2', { replace: true });
      }}
      confirmButtonText={'다음'}
      prevButtonHandler={() => {
        navigate('/survey/progress/sell-tractor/tire-condition', { replace: true });
      }}
      steps={steps}
      currentStep={currentStep}
    >
      <SurveyForm>
        <SurveyInputSection>
          <SurveyInputHeader inputTitle={'판매 희망가'} isRequired />
          <InputContainer>
            <BasicInputWithExtras
              type={'number'}
              inputValue={hopeSellingPrice}
              placeholder={'예) 6500'}
              onChange={(value: InputValue) => setHopeSellingPrice(value as number)}
            >
              <Surfix>{'만원'}</Surfix>
            </BasicInputWithExtras>
            <PriceHelperText price={hopeSellingPrice!} />
          </InputContainer>
        </SurveyInputSection>
      </SurveyForm>
    </SellTractorSurveyPageWrapper>
  );
};

const SurveyInputSection = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px) 24px var(--radius-large, 16px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`;

const Surfix = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */

  white-space: nowrap;
`;
